module.exports = __webpack_public_path__ + "static/img/news.53d2f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/news.jpg
// module id = Cf31
// module chunks = 0